export function money(cents) {
  return Number.isFinite(cents) ? new Intl.NumberFormat("de-CH", { style: "currency", currency: "CHF" }).format(cents / 100) : "—"
}

export function date(value) {
  if (!value) return "—"
  const parsed = new Date(value)
  return Number.isFinite(parsed.getTime()) ? new Intl.DateTimeFormat("de-CH", { timeZone: "Europe/Zurich" }).format(parsed) : "—"
}

export function today() {
  const parts = new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Zurich", year: "numeric", month: "2-digit", day: "2-digit" }).formatToParts(new Date())
  const get = (type) => parts.find((part) => part.type === type).value
  return `${get("year")}-${get("month")}-${get("day")}`
}

export function requestId() {
  const bytes = new Uint8Array(16)
  window.crypto.getRandomValues(bytes)
  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("")
}

export function statusLabel(status) {
  return { temporary: "Temporär", signed: "Unterzeichnet", submitted: "Beim Büro", accepted: "Freigegeben", rejected: "Zur Korrektur", archived: "Archiviert" }[status] || status
}
